export const exchangeReferalMap = {
  binance: 'https://accounts.binance.com/en/register?ref=196250967',
  kucoin: 'https://www.kucoin.com/r/af/r3JXS9A',
  mexc: 'https://www.mexc.com/register?inviteCode=1SVX7',
}

export const exchangeMaketsReferalMap = {
  binance: 'https://www.binance.com/en/trade/{symbol}?ref=196250967',
  mexc: 'https://www.mexc.com/exchange/{symbol}?inviteCode=1SVX7',
}
